import Vue from 'vue'
import VueRouter from 'vue-router'
import contenido from '@/content'

Vue.use(VueRouter);

/* -----------------------------------------------------------------------------
   RUTAS FIJAS
   -------------------------------------------------------------------------- */
const rutasFijas = [
  {
    path: '/',
    name: 'PageHome',
    component: () => import(/* webpackChunkName: "page-home" */ '../components/PageHomeEsp.vue')
  },
  {
    path: '/cat',
    name: 'PageHomeCat',
    component: () => import(/* webpackChunkName: "page-home" */ '../components/PageHomeCat.vue')
  },
  {
    path: '/aviso-legal-esp',
    name: 'AvisoLegalEsp',
    component: () => import(/* webpackChunkName: "page-legal" */ '../components/PageAvisoLegalEsp.vue')
  },
  {
    path: '/aviso-legal-cat',
    name: 'AvisoLegalCat',
    component: () => import(/* webpackChunkName: "page-legal" */ '../components/PageAvisoLegalCat.vue')
  },
  {
    path: '/politica-cookies-esp',
    name: 'PoliticaCookiesEsp',
    component: () => import(/* webpackChunkName: "page-legal" */ '../components/PagePoliticaCookiesEsp.vue')
  },
  {
    path: '/politica-cookies-cat',
    name: 'PoliticaCookiesCat',
    component: () => import(/* webpackChunkName: "page-legal" */ '../components/PagePoliticaCookiesCat.vue')
  },
  {
    path: '/calculadora-itp',
    name: 'CalculadoraItpEsp',
    component: () => import(/* webpackChunkName: "page-calculadora-itp" */ '../components/PageCalculadoraItpEsp.vue')
  },
  {
    path: '/calculadora-itp-cat',
    name: 'CalculadoraItpCat',
    component: () => import(/* webpackChunkName: "page-calculadora-itp" */ '../components/PageCalculadoraItpCat.vue')
  },
  {
    path: '/calculadora-matriculacion',
    name: 'CalculadoraMatriculacionEsp',
    component: () => import(/* webpackChunkName: "page-calculadora-matriculacion" */ '../components/PageCalculadoraMatriculacionEsp.vue')
  },
  {
    path: '/calculadora-matriculacion-cat',
    name: 'CalculadoraMatriculacionCat',
    component: () => import(/* webpackChunkName: "page-calculadora-matriculacion" */ '../components/PageCalculadoraMatriculacionCat.vue')
  },
  {
    path: '/email-signatures',
    name: 'PageEmailSignatures',
    component: () => import(/* webpackChunkName: "page-email-signatures" */ '../components/PageEmailSignatures.vue')
  }
];

/* -----------------------------------------------------------------------------
   RUTAS DEL SILO
   Se generan solas a partir de src/content. Añadir una categoría o una página
   comercial no requiere tocar este archivo: basta con editar el contenido.

   Estructura resultante:
     /seguros                      · página de categoría
     /seguros/hogar-tarragona      · página comercial
     /cat/assegurances             · categoría en catalán
     /cat/assegurances/llar-tarragona
   -------------------------------------------------------------------------- */
const PageCategoria = () => import(/* webpackChunkName: "silo" */ '../components/PageCategoria.vue');
const PageServicio = () => import(/* webpackChunkName: "silo" */ '../components/PageServicio.vue');

const rutasSilo = [];

contenido.CATEGORIAS.forEach(function (cat) {
  contenido.IDIOMAS_LISTA.forEach(function (lang) {
    const base = contenido.urlCategoria(cat, lang);

    /* Página de categoría */
    rutasSilo.push({
      path: base,
      name: 'Categoria-' + cat.id + '-' + lang,
      component: PageCategoria,
      props: { categoriaId: cat.id, lang: lang }
    });

    /* Páginas comerciales. Una sola ruta con :slug las cubre todas;
       el componente resuelve el contenido y descarta las no publicadas. */
    rutasSilo.push({
      path: base + '/:slug',
      name: 'Servicio-' + cat.id + '-' + lang,
      component: PageServicio,
      props: function (route) {
        return {
          categoriaId: cat.id,
          lang: lang,
          slug: route.params.slug
        };
      }
    });
  });
});

/* -----------------------------------------------------------------------------
   Cualquier URL que no exista vuelve al home en lugar de dejar pantalla blanca
   -------------------------------------------------------------------------- */
const rutaFallback = [
  { path: '*', redirect: '/' }
];

export const router = new VueRouter({
  mode: 'history',
  routes: rutasFijas.concat(rutasSilo, rutaFallback),

  /* Al cambiar de página siempre arriba, salvo que el navegador vuelva atrás */
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) return savedPosition;
    if (to.hash) return { selector: to.hash };
    return { x: 0, y: 0 };
  }
});

export default router
